import { render, staticRenderFns } from "./MatchPageResult.vue?vue&type=template&id=78b9fcab&"
import script from "./MatchPageResult.vue?vue&type=script&lang=js&"
export * from "./MatchPageResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports